export default __webpack_public_path__ + "static/media/alert-tick.bc64d120.svg";